export default __webpack_public_path__ + "static/media/404Wide.ea14ccb4.svg";